import { useQuery } from '@tanstack/vue-query'
import Help from '@/api/Dara/Help'
import { oneHourInMS } from '@/composable/useDatesAndTimes'
import { helpKeys } from '@/composable/queries/keys'

export const useHelpQuery = (
  routeName: Ref<string>,
  enabled: Ref<boolean>,
) =>
  useQuery({
    queryKey: helpKeys.detail(routeName),
    queryFn: () => Help.get(routeName.value),
    staleTime: oneHourInMS,
    enabled,
  })

export const useHelpDocsQuery = (
  routeName: Ref<string>,
  enabled: Ref<boolean>,
) =>
  useQuery({
    queryKey: helpKeys.docs(routeName),
    queryFn: () => Help.getDocs(routeName.value),
    staleTime: oneHourInMS,
    enabled,
  })
